module.exports = __webpack_public_path__ + "img/jgz.5e8e25bf.svg";